export default "__VITE_ASSET__CpVKjSW9__"